// extracted by mini-css-extract-plugin
export default {"list":"segment-branding-select-row_list__AlXOC"};